import Loadable from '@townsquare/loadable';
import type { RouteContext } from '@townsquare/router/routing-types';
import { aggTeamsDirectoryRoute } from '@townsquare/routes/agg-teams-directory-view';
import { tqlExplainerResource } from '@townsquare/tql/resource';

import { teamDirectoryTableResource } from './resources/team-directory-table';

const TeamsDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () => import(/* webpackChunkName: "agg-teams-directory-view" */ './TeamDirectory'),
	loading: () => null,
});

aggTeamsDirectoryRoute.component = TeamsDirectoryLoadable;
aggTeamsDirectoryRoute.relayEnvironment = 'agg';
aggTeamsDirectoryRoute.resources = [
	teamDirectoryTableResource,
	tqlExplainerResource,
];
export const aggTeamsDirectoryRouterRoute = aggTeamsDirectoryRoute;
